<router-outlet> </router-outlet>
@if (currentUser && isShowPopup) {
  <div>
    <app-novatiq-popup
      [title]="'expiryLockPopupTitle' | translate"
      [showFooter]="false"
      [id]="'app-idle-logout'"
      [defaultClose]="false"
    >
      <div slot="popup-body">
        <novatiq-expiry-lock [currentUser]="currentUser" (resumeSession)="resumeUserSession($event)">
        </novatiq-expiry-lock>
      </div>
    </app-novatiq-popup>
  </div>
}
<novatiq-spinner></novatiq-spinner>
<p-toast key="passwordReset">
  <ng-template let-message #headless let-closeFn="closeFn">
    <div class="password-expiry-toast-container">
      <div class="custom-toast-content">
        <div class="toast-icon"><i class="pi pi-info-circle"></i></div>
        <div class="toast-message" style="flex: 1">
          <div class="toast-title">{{ message.detail }}</div>
          <p class="toast-subtitle">{{ 'passwordExpiry.resetPasswordNowAsk' | translate }}</p>
        </div>
      </div>
      <div class="toast-actions">
        <p-button size="small" label="{{ 'Continue' | translate }}" (onClick)="onPasswordReset()" />
        <p-button size="small" label="{{ 'notNow' | translate }}" severity="secondary" (onClick)="closeFn($event)" />
      </div>
    </div>
  </ng-template>
</p-toast>
